// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BookingController from "./booking_controller"
application.register("booking", BookingController)

import ExceptionFormController from "./exception_form_controller"
application.register("exception-form", ExceptionFormController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)
